export default {
  select_size: 'Select a size',
  required: 'Required',
  optional: 'Optional',
  select_up_to: 'Select up to {{maxCount}}',
};
